import { ApolloError, useQuery } from "@apollo/client";

import { gql } from "@apollo/client";
import { canonicalAsPath } from "../../Utils/canonicalAsPath";
import { seoMetaTags } from "./model";
import { useRouter } from "next/router";

interface SeoHookResponse {
	seoMetaTags: seoMetaTags;
	loading: boolean;
	error: ApolloError;
}

const QUERY_SEO = gql`
	query SEO($url: String!) {
		seoMetaTags(url: $url) {
			h1
			title
			breadcrumbs {
				text
				url
			}
			url
			description
			og_image
			noindex
			canonical
			site_name
			links
			text
			seoLanding {
				text
				image
				id
			}
			keywords
			ios_app_id
		}
	}
`;

export const useSEO = (): SeoHookResponse => {
	const router = useRouter();

	const { data, loading, error } = useQuery(QUERY_SEO, {
		variables: {
			// Sólo el path (INF-269). Verificado contra el backend: `h1`, `title`, `canonical`,
			// `noindex`, `breadcrumbs`, `text`, `keywords` y `seoLanding` son idénticos con y sin
			// query-string en CO/UY/PY; lo único que cambiaba era el echo de `url`. La paginación
			// que sí cambia el SEO viaja en el path (`/pagina2`), no como `?pagina=N`.
			url: canonicalAsPath(router.asPath),
		},
	});

	let seoMetaTags: any = { ...data?.seoMetaTags };
	if (seoMetaTags && seoMetaTags.breadcrumbs?.length > 1) {
		seoMetaTags["lastSearch"] = seoMetaTags.breadcrumbs[seoMetaTags.breadcrumbs.length - 2];
	}

	return {
		loading,
		seoMetaTags: seoMetaTags,
		error,
	};
};
